attachEvent('.basket-item__minus', 'click', (ev) => {
  ev.target.closest('.basket-item__amount-wrap').querySelector('.basket-item__amount').stepDown();
});

attachEvent('.basket-item__plus', 'click', (ev) => {
  ev.target.closest('.basket-item__amount-wrap').querySelector('.basket-item__amount').stepUp();
});

attachEvent('.basket-item__remove', 'click', (ev) => {
  const parent = ev.target.closest('.basket-item');
  slideUp(parent, 300);
  setTimeout(() => {
    parent.remove();
  }, 300);
});

attachEvent('.basket-items__remove', 'click', (ev) => {
  ev.target.closest('.basket-items').remove();
});
